import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../redux/registrationPopupActions';
import * as logInActions from 'src/components/SignInPopup/redux/signInPopupActions';
import styles from 'src/styles/AuthPopup.scss';
import TelephoneInput from 'react-telephone-input';
import config from 'src/config';
import {isValidNumber} from 'src/logic/utils';
import cx from 'classnames';
import debounce from 'lodash/debounce';
import * as texts from 'src/texts';
const phoneInputImgs = require('src/imgs/flags.png');
import {findDOMNode} from 'react-dom';
import PopoverTrigger from 'src/components/popover/PopoverTrigger';
import fm from 'src/logic/formatMessage';
import FirstStepLayout from './FirstStepLayout';

class RegistrationInputFirstStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    };
  }

  submitPhone = (e) => {
    e.preventDefault();
    const value = this.refs.phoneInput.getInstance().getValue();
    if (!isValidNumber(value)) {
      return false
    }
    this.props.sendNumber(value, this.props.isCompact)
      .then((res) => {
        if (res.error === config.userAlreadyRegisteredServerErrorText && this.props.isCompact) {
          this.props.openSignInPopup();
        }
      });
  };

  onChange = debounce((value) => {
    if (value.length < config.minLengthForNumberVerifying) {
      this.setState({isValid: true});
      return this.props.resetRegErrors();
    }
      this.setState({
        isValid: isValidNumber(value)
      });

  }, 200);

  render() {

    const {regInputCurStep, sentNumberErr, popoverOnTop, isCompact} = this.props,
      {isValid} = this.state,
      phoneInputContainerClassName = {
      [styles.telephoneInputContainer]: true,
      [styles.invalidInput]: !isValid || !!sentNumberErr,
      'w-100': !isCompact
    },
      phoneNumberTooltipType = (isValid && !sentNumberErr)
      ? ''
      : 'error',
      phoneNumberTooltipText = (isValid && !sentNumberErr)
        ? 'Укажите ваш настоящий номер телефона'
        : sentNumberErr;
    const elems = {
      input: (
        <PopoverTrigger
          alwaysActive
          onTop
          type={phoneNumberTooltipType}
          content={phoneNumberTooltipText}
          placement="left">
          <div
            className={styles.inputContainer}>
            <TelephoneInput
              ref="phoneInput"
              classNames={cx(phoneInputContainerClassName)}
              defaultCountry='ru'
              preferredCountries={config.phoneInputCodeSelectorPreferredCountries}
              flagsImagePath={phoneInputImgs}
              onChange={this.onChange}/>
          </div>
        </PopoverTrigger>
      ),
      text: (
        <p className={styles.realNumberPrompt}>

        </p>
      ),
      btn: (
        <button>
          {isCompact ? 'Выслать пароль' : 'Выслать код подтверждения'}
        </button>
      )
    };
    return (
      <form className={styles.regBlockContainer} onSubmit={this.submitPhone}>
        <FirstStepLayout {...elems} isCompact={isCompact}/>
      </form>
    );
  }
}

export default connect(
  (state) => ({...state.registrationPopupReducer}),
  (dispatch) => ({
    ...bindActionCreators(actions, dispatch),
    ...bindActionCreators(logInActions, dispatch)
  })
)(RegistrationInputFirstStep);



/** WEBPACK FOOTER **
 ** ./src/components/RegistrationPopup/elements/RegistrationInputFirstStep.jsx
 **/